import React from 'react';
import privacyData from '../privacy.json';

function PrivacyPolicyModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop with blur effect */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal container */}
      <div className="relative min-h-screen flex items-center justify-center p-4">
        <div className="relative bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b">
            <h2 className="text-2xl font-bold text-gray-800">{privacyData.title}</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Content */}
          <div className="p-6 overflow-y-auto max-h-[calc(90vh-8rem)]">
            <p className="text-gray-600 mb-6">{privacyData.introduction}</p>
            
            {privacyData.sections.map((section, index) => (
              <div key={index} className="mb-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">{section.title}</h3>
                
                {section.items ? (
                  <ul className="list-disc pl-5 space-y-3">
                    {section.items.map((item, itemIndex) => (
                      <li key={itemIndex} className="text-gray-600">
                        <span className="font-medium text-gray-700">{item.name}:</span> {item.description}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-gray-600">{section.description}</p>
                )}
              </div>
            ))}

            <p className="text-sm text-gray-500 mt-6">
              Effective Date: {privacyData.effective_date}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyModal;
